/* eslint-disable react/no-unused-prop-types */
import React, { useEffect } from "react";
import {
  BasicTooltip,
  screenSizes,
  tooltipPositions
} from "@streeteasy/design-system";
import moment from "moment-timezone";
import { bool, number, shape, string } from "prop-types";

import { useIsMobile } from "src/shared/utilities/customHooks";

import { useOHBehavior, useOHData } from "../../redux/hooks/openHousesHooks";
import { useUIBehavior } from "../../redux/hooks/uiHooks";
import handleLoginFlow from "../../utilities/handleLoginFlow";
import AddToCalendar from "../AddToCalendar";
import * as S from "./styled";

const OpenHouseItemHDP = props => {
  const { sendAddToCalendarGA } = useUIBehavior();
  const { featureFlags, userIsPresent } = useOHData();
  const { deregister, register } = useOHBehavior();
  const isMobile = useIsMobile(screenSizes.LARGE_SCREEN);
  const hideSignUpButton =
    featureFlags.includes("ursa_open_house_bao") && props.byApptOnly;

  useEffect(() => {
    handleLoginFlow().registerOHAfterReload(register);
  }, []);

  const renderConfirmation = () => (
    <>
      <S.CheckIcon />
      <S.SubInfo>
        You&apos;re signed up! Track your open houses in{" "}
        <S.Link href="/lists" target="_blank" underlined>
          My Activity
        </S.Link>
        .
      </S.SubInfo>
    </>
  );

  const onAnalyticsEvent = openHouseId => {
    sendAddToCalendarGA(openHouseId);
  };

  const renderRegisteredUsersInfo = () => {
    const personCounter = props.numberOfRegisteredUsers;
    if (props.byApptOnly) {
      return <S.SubInfo>By appointment only</S.SubInfo>;
    }
    if (personCounter > 0) {
      return (
        <S.SubInfo>
          {personCounter} {personCounter > 1 ? "people" : "person"} signed-up
        </S.SubInfo>
      );
    }
    return <S.SubInfo>Be first to sign up!</S.SubInfo>;
  };

  const renderOpenHouseTimeWindow = () => {
    const day = moment(props.startsAt)
      .tz("America/New_York")
      .format("ddd, MMM DD");
    const startTime = moment(props.startsAt)
      .tz("America/New_York")
      .format("LT");
    const endTime = moment(props.endsAt)
      .tz("America/New_York")
      .format("LT");
    return (
      <>
        {day},{isMobile && !props.userIsRegistered && <br />} {startTime} -{" "}
        {endTime}
      </>
    );
  };

  return (
    <S.Wrapper>
      <S.InfoBox>
        <S.OHTime>{renderOpenHouseTimeWindow()}</S.OHTime>
        <S.SubInfoWrapper>
          {props.userIsRegistered
            ? renderConfirmation()
            : renderRegisteredUsersInfo()}
        </S.SubInfoWrapper>
      </S.InfoBox>
      <S.Actions isUserRegistered={props.userIsRegistered}>
        {!hideSignUpButton && !props.userIsRegistered && (
          <S.SignupButton
            onClick={() =>
              userIsPresent
                ? register(props.id)
                : handleLoginFlow().triggerScenario(props.id)
            }
          >
            Sign up
          </S.SignupButton>
        )}
        {props.userIsRegistered && (
          <>
            {!isMobile && (
              <AddToCalendar
                handleAnalyticsEvent={openHouseId =>
                  onAnalyticsEvent(openHouseId)
                }
                openHouseData={props.openHouseData}
                openHouseId={props.id}
              />
            )}
            <BasicTooltip
              className="a11y"
              content="Remove"
              position={tooltipPositions.BOTTOM}
            >
              <S.RemoveButton
                onClick={() => {
                  deregister(props.id);
                }}
              >
                <S.RemoveIcon />
              </S.RemoveButton>
            </BasicTooltip>
          </>
        )}
      </S.Actions>
    </S.Wrapper>
  );
};

OpenHouseItemHDP.propTypes = {
  byApptOnly: bool.isRequired,
  endsAt: string.isRequired,
  id: number.isRequired,
  numberOfRegisteredUsers: number.isRequired,
  openHouseData: shape({}).isRequired,
  startsAt: string.isRequired,
  userIsRegistered: bool.isRequired
};

export default OpenHouseItemHDP;
